<template>
  <div class="line-desc-faq">
    <div class="question-box">
      <span class="main-index">Q:</span>
      <div class="question">{{$t('title')}}</div>
    </div>
    <div class="answer-box">
      <span class="main-index">A:</span>
      <div class="answer">
        <p v-for="(item, index) of $t('content')" :key="index">{{item}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import locales from './lang'

export default {
  name: 'line-desc-faq',
  locales
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/variables";

  .line-desc-faq {
    padding: .2rem;
    max-width: 1080px;
    margin: 0 auto;
  }
  .question-box {
    position: relative;
    color: #333;
    .main-index {
      line-height: .26rem;
      position: absolute;
      top: 0;
      left: 0;
    }
    .question {
      line-height: .26rem;
      margin: 0 0 0 .26rem;
    }
  }

  .answer-box {
    position: relative;
    color: #999;
    .main-index {
      line-height: .26rem;
      position: absolute;
      top: 0;
      left: 0;
    }
    .answer {
      margin: .15rem 0 .4rem .26rem;
      font-size: .14rem;
      color: #999;
      line-height: .26rem;
      a {
        color: $base-green;
        cursor: pointer;
      }
    }
  }

  @media screen and (max-width: 767px) {
    .link-desc-faq {
      padding: .2rem;
      margin: 0 auto;
    }
  }
</style>



// WEBPACK FOOTER //
// lineDescFAQ.vue?4e22093a